import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import app from '../config/firebase';
import { getFirestore, doc, getDoc } from "firebase/firestore";

const db = getFirestore(app);

export default function Article() {
    const { ArticleId } = useParams();
    const [articleData, setArticleData] = useState(null);

    useEffect(() => {
        if (!articleData) { 
            const fetchArticle = async () => {
                const docRef = doc(db, "articles", ArticleId);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setArticleData(data.post);
                } else {
                    console.log("No such document!");
                }
            };

            fetchArticle();
        }
    }, [ArticleId, articleData]); 

    if (!articleData) {
        return <p>Loading...</p>;
    }

    return (
        <div dangerouslySetInnerHTML={{ __html: articleData }} />
    );
}